// import simpleRequest from '../request/simple'
import router from '../app/router'
import localStorage from '../utils/localStorage'
import './login/install'
import API from '../api'
import _ from '../utils/datetime'
import {
  get
} from '../utils/index'
import hbLogin from './hbLogin';
import thirdLogin from './thirdLogin';

export default {
  login({
    target_url,
    rp,
    method,
    callback = null
  } = {}) {

    if (!target_url) {
      target_url = window.location.href;
    }
    if (!rp) {
      rp = router.currentRoute && router.currentRoute.fullPath || '';
    }

    // 检查是否需要跳转去航班的登录页面
    if (hbLogin.checkNeedHbLogin()) {
      let loginUrl = hbLogin.generateHbLoginUrl(target_url)
      console.log('loginUrl: ', loginUrl)

      if (method === 'replace') {
        window.location.replace(loginUrl);
      } else {
        window.location.href = loginUrl;
      }
      return Promise.reject({
        name: 'ToHangbanLogin',
        message: '跳转去航班登录页'
      })
    } else if (thirdLogin.checkNeedThirdLogin()) {
      //根据不同的ptid处理不同的登录请求
      return thirdLogin.thirdLogin().catch(err => {
        if (err && err.type === "PHONECODE_LOGIN") {
          return this.phoneCodeLogin({
            target_url,
            rp,
            method
          });
        } else {
          throw err;
        }
      }).then(() => {
        // 如果已经加载了页面，就用单页跳转，否则用location
        // const matched = router.getMatchedComponents(rp);
        // if (rp && matched && matched.length > 0) {
        //   router.replace({
        //     path: rp
        //   });
        // } else {
        //   location.replace(target_url);
        // }

        if (method === 'replace') { //页面已加载
          router.go(-1);
        } else {
          router.push({
            path: rp
          });
        }

      });
    } else {
      return this.phoneCodeLogin({
        target_url,
        rp,
        method,
        callback
      });
    }
  },

  phoneCodeLogin({
    target_url,
    rp,
    method,
    callback = null
  } = {}) {
    return new Promise(() => {
      return router[method || 'push']({
        name: 'login/sms',
        params: {
          ru: target_url,
          rp,
          callback
        }
      });
    });
  },

  logout() {
    this.clearStorage()

    return Promise.resolve()
  },

  getToken() {
    let authcode = localStorage.get('authcode')
    if (authcode) {
      let refreshExpiretime = localStorage.get('refreshExpiretime')
      refreshExpiretime = refreshExpiretime ? _.toDate(refreshExpiretime).getTime() : null
      if (refreshExpiretime && refreshExpiretime > Date.now() || !refreshExpiretime) { // refreshcode未过期或者refreshcode过期时间为空
        return Promise.resolve({
          authcode
        })
      } else {
        return Promise.reject({
          name: 'AuthError',
          message: '用户信息已过期'
        })
      }
    } else {
      return Promise.reject({
        name: 'AuthError',
        message: '获取用户信息失败(w)'
      })
    }
  },

  refreshToken() {
    let refreshcode = localStorage.get('refreshcode')
    if (refreshcode) {
      return API.login['41012'](refreshcode).then(r => {
        console.log('refreshToken r: ', r)
        let code = get(r, 'res.hd.code')
        if (code === 1) {
          let bd = get(r, 'res.bd')
          localStorage.set('authcode', bd.authcode)
          localStorage.set('authExpiretime', bd.authExpiretime)

          //延长refreshToken
          setTimeout(this.extendRefreshToken, 1000)

          return {
            authcode: bd.authcode
          }
        }
      }).catch(e => {
        console.log('refreshToken e: ', e)
        this.clearStorage()
        throw e
      })
    } else {
      return Promise.reject(null)
    }
  },

  extendRefreshToken() {
    let refreshcode = localStorage.get('refreshcode')
    let refreshExpiretime = localStorage.get('refreshExpiretime')
    refreshExpiretime = refreshExpiretime ? _.toDate(refreshExpiretime).getTime() : null

    if (refreshcode && refreshExpiretime && refreshExpiretime > Date.now()) { //刷新token未过期
      API.login['41013'](refreshcode).then(r => {
        let code = get(r, 'res.hd.code')
        if (code === 1) {
          let bd = get(r, 'res.bd')
          localStorage.set('refreshcode', bd.refreshcode)
          localStorage.set('refreshExpiretime', bd.refreshExpiretime)
        }
      })
    }
  },

  clearStorage() {
    localStorage.remove('authcode')
    localStorage.remove('refreshcode')
    localStorage.remove('authExpiretime')
    localStorage.remove('refreshExpiretime')
    localStorage.remove('user')
  },

  handleLoginRes(errType) {
    return function(r) {
      let res = r && r.res
      if (res && res.hd && res.hd.code === 1) {
        return res.bd
      } else {
        throw {
          name: errType || 'RequestAuthError',
          message: '请求用户信息失败'
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/auth/web.js